export default __webpack_public_path__ + "static/media/laundry2-afterB-1440w.d1fe8bd8.avif";